import { jsx as t, jsxs as d } from "react/jsx-runtime";
import { components as u } from "react-select";
import "styled-components";
import { useThemeInMode as T } from "../../../context/theme/hooks.js";
import { typographyBodySizeMap as k, typographyBodyLineHeightMap as A } from "../../../styles/typography/typography.js";
import "../../layout/Stack/Stack.js";
import i from "../../layout/Box/Box.js";
import N from "../../layout/Inline/Inline.js";
import "../../layout/Center/Center.js";
import "react";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import "../../../index-CZ8zjHGv.js";
import "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import "../../../hooks/link/index.js";
import I from "../../other/Var/Var.js";
import D from "../Checkbox/Checkbox.js";
import V from "./components/DropdownControl.js";
import m from "./components/MultiValueLabel.js";
import B from "./components/SearchInput.js";
import { SelectAllOption as H } from "./hooks/useSelectAll.js";
const me = {
  Option: P,
  Menu: X,
  MenuList: R,
  Control: j
};
function P({
  children: o,
  ...e
}) {
  const { dataNoTranslateOption: l } = e.selectProps, n = o === H.label, r = () => {
    e.selectOption && e.selectOption(e.data);
  }, a = T();
  return /* @__PURE__ */ t(u.Option, { ...e, children: /* @__PURE__ */ t(i, { display: "flex", flexDirection: "row", alignItems: "center", children: /* @__PURE__ */ t(
    D,
    {
      checked: e.isSelected,
      name: e.label,
      onChange: r,
      disabled: e.isDisabled,
      children: /* @__PURE__ */ t(
        i,
        {
          cursor: e.isDisabled ? "default" : "pointer",
          dataNoTranslate: l && !n || void 0,
          color: e.isSelected ? a["primary-high-content"] : a["neutral-high-content"],
          children: o
        }
      )
    }
  ) }) });
}
function R({
  children: o,
  ...e
}) {
  const { listHeader: l, dataNoTranslateListHeader: n } = e.selectProps;
  return /* @__PURE__ */ d(u.MenuList, { ...e, children: [
    l && /* @__PURE__ */ t(i, { paddingY: "large", paddingX: "large", children: /* @__PURE__ */ t(i, { paddingX: "small", children: /* @__PURE__ */ t(
      i,
      {
        dataNoTranslate: n,
        fontWeight: "bold",
        ...k.small,
        ...A.small,
        children: l
      }
    ) }) }),
    o
  ] });
}
function X({
  children: o,
  ...e
}) {
  const { onChangeSearch: l, searchValue: n, isSearchable: r } = e.selectProps;
  return /* @__PURE__ */ d(u.Menu, { ...e, children: [
    r && /* @__PURE__ */ t(
      B,
      {
        autoFocus: !0,
        onChangeSearch: l,
        searchValue: n
      }
    ),
    o
  ] });
}
function j({
  children: o,
  getValue: e,
  ...l
}) {
  const {
    isDisabled: n,
    isSearchable: r,
    placeholder: a,
    ariaLabel: b,
    onClickMenu: g,
    menuIsOpen: C,
    removeAll: h,
    removeItem: L,
    fixedValues: M = [],
    maxMultiValueLabels: p,
    dataNoTranslateOption: S,
    allSelected: O,
    disableAllSelected: v
  } = l.selectProps, c = e();
  function x() {
    return !v && O ? /* @__PURE__ */ t(m, { removeable: !n, onClickRemove: h, children: "All selected" }) : p && c.length > p ? /* @__PURE__ */ d(m, { removeable: !n, onClickRemove: h, children: [
      /* @__PURE__ */ t(I, { children: c.length }),
      " selected"
    ] }) : c.map(({ label: y, value: s }) => /* @__PURE__ */ t(
      m,
      {
        dataNoTranslate: S,
        removeable: !M.includes(s) && !n,
        onClickRemove: () => L(s),
        children: w(y)
      },
      s
    ));
  }
  return /* @__PURE__ */ t(
    V,
    {
      searchable: r,
      disabled: n,
      ariaLabel: b,
      onClick: g,
      menuIsOpen: C,
      children: c.length ? /* @__PURE__ */ t(N, { space: "small", children: x() }) : /* @__PURE__ */ t(i, { children: a })
    }
  );
}
const f = 20;
function w(o) {
  return o.length > f ? o.substring(0, f).concat("...") : o;
}
export {
  me as default
};
